import axios from 'axios';
import ApiUrl from './config';
import { Gender } from './apiClient';

// Кабинет родителя (роль «Представитель»). Эндпоинтов ещё нет в сгенерированном apiClient.

export const REPRESENTATIVE_ROLE = 'Представитель';

export interface ChildApplication {
  participantId: number;
  tournamentId: number;
  tournamentName: string;
  startDate: string;
  endDate: string;
  registrationEndDate: string;
  isStarted: boolean;
  isFinished: boolean;
  weight: number;
  organization?: string;
  rank?: string;
}

export interface Child {
  id: number;
  lastName: string;
  firstName: string;
  patronymic?: string;
  birthDate: string;
  city: string;
  gender?: Gender;
  applications: ChildApplication[];
}

export interface ChildPayload {
  lastName: string;
  firstName: string;
  patronymic?: string;
  birthDate: Date;
  city: string;
  gender: Gender;
  /** Согласие родителя на обработку персональных данных ребёнка (при создании). */
  personalDataConsent?: boolean;
}

export async function getChildren(): Promise<Child[]> {
  const response = await axios.get<Child[]>(`${ApiUrl}/api/Guardian/GetChildren`);
  return response.data ?? [];
}

export async function addChild(payload: ChildPayload): Promise<number> {
  const response = await axios.post<{ id: number }>(`${ApiUrl}/api/Guardian/AddChild`, payload);
  return response.data.id;
}

export async function updateChild(id: number, payload: ChildPayload): Promise<void> {
  await axios.put(`${ApiUrl}/api/Guardian/UpdateChild`, payload, { params: { id } });
}

export async function removeChild(id: number): Promise<void> {
  await axios.delete(`${ApiUrl}/api/Guardian/RemoveChild`, { params: { id } });
}

/** Возраст ребёнка на указанную дату (дата рождения приходит как полночь по местному времени клиента). */
export function childAgeOn(birthDate: string | Date, on: Date = new Date()): number {
  const birth = new Date(birthDate);
  let age = on.getFullYear() - birth.getFullYear();
  const monthDiff = on.getMonth() - birth.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && on.getDate() < birth.getDate())) age--;
  return age;
}
